import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Col, Row, Tab, Nav } from 'react-bootstrap';
import '../../assets/css/dashboard.scss';
import '../../assets/css/customermanagement.scss';
import '../../assets/css/WorkQueue.scss';
import 'react-datepicker/dist/react-datepicker.css';
import WorkQueuesViewAssignedTable from './WorkQueuesViewAssignedTable';
import WorkQueuesAssignToTable from './WorkQueuesAssignToTable';
import Download from '../MainSection/Download/Download';
import { useDispatch, useSelector } from 'react-redux';
import { loadAssignedModulesDropdownData, loadViewAssignedWorkquesData, loadWorkquesData } from '../../redux/action';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';
import moment from 'moment';
import UsersWQViewAssignedToTable from './UsersWQViewAssignedToTable';

const WorkQueues = () => {

    let dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const { workqueuesData = [] } = useSelector((state) => state.data);
    const { getViewAssignedWorkqueueData = [] } = useSelector((state) => state.data);
    const { assignedModulesDropdown } = useSelector((state) => state.data);
    const [activeKey, setActiveKey] = useState('assignTo'); // Default active tab
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [searchParams, setSearchParams] = useState('');
    const [searchParamsForViewAssigned, setSearchParamsForViewAssigned] = useState('');
    const [searchTextForViewAssigned, setSearchTextForViewAssigned] = useState("");
    const [searchQueryForViewAssigned, setSearchQueryForViewAssigned] = useState('');

    // const workqueuesDatas = (moduleID = null) => {
    //     dispatch(loadWorkquesData(setLoading, searchQuery, moduleID, searchParams));
    // }
    // useEffect(() => {
    //     workqueuesDatas();
    // }, [searchQuery, searchParams]);

    const workqueuesDatas = (moduleID = null, activeTab) => {
        if (activeTab === "assignTo") {
            dispatch(loadWorkquesData(setLoading, searchQuery, moduleID, searchParams));
        } else {
            // dispatch(loadWorkquesData(setLoading, searchQueryForViewAssigned, moduleID, searchParamsForViewAssigned));
            dispatch(loadViewAssignedWorkquesData(setLoading, searchQueryForViewAssigned, moduleID, searchParamsForViewAssigned));
        }
    };

    useEffect(() => {
        if (activeKey === "assignTo") {
            workqueuesDatas(null, "assignTo");
        } else {
            workqueuesDatas(null, "viewAssigned");
        }
    }, [searchQuery, searchParams, searchQueryForViewAssigned, searchParamsForViewAssigned, activeKey]);

    useEffect(() => {
        dispatch(loadAssignedModulesDropdownData());
        if (signInDetails[0]?.SignInType === "User") {
            dispatch(loadViewAssignedWorkquesData(setLoading, searchQueryForViewAssigned, null, searchParamsForViewAssigned));
        }
    }, [])

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        const dataToExport = activeKey === 'assignTo'
            ? workqueuesData?.map(item => ({
                "PRIORITY STATUS": item.WorkQueuePriority || "NA",
                "RULE": item.WorkQueueRuleName || "NA",
                "MODULES": item.Module || "NA",
                "WORK QUEUE COUNT": item.WorkQueueCount || "NA",
                "ASSIGN TO": item.AssignedTo || "NA",
                "ASSIGNED DATE": item.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA",
            }))
            : getViewAssignedWorkqueueData?.map(item => ({
                "PRIORITY STATUS": item.WorkQueuePriority || "NA",
                "RULE": item.WorkQueueRuleName || "NA",
                "MODULES": item.Module || "NA",
                "ASSIGN TO": item.AssignedTo || "NA",
                "CURRENT COUNT": item.WorkQueueCount || "NA",
                "ASSIGN DATE": item.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA",
                "DESCRIPTION": item.WorkQueueDescription || "NA",
            })) || [];

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, activeKey === 'assignTo' ? "AssignToWorkqueue" : "ViewAssignedWorkqueue");

        XLSX.writeFile(wb, activeKey === 'assignTo' ? 'assign_to_workqueue.xlsx' : 'view_assigned_workqueue.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' });

        // Title
        doc.setFontSize(18);
        doc.text(activeKey === 'assignTo' ? "Assign To Work Queue Data" : "View Assigned Work Queue Data", 14, 20);

        const dataToExport = activeKey === 'assignTo'
            ? workqueuesData?.map(item => ([
                item.WorkQueuePriority || "NA",
                item.WorkQueueRuleName || "NA",
                item.Module || "NA",
                item.WorkQueueCount || "NA",
                item.AssignedTo || "NA",
                item.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA",
            ]))
            : getViewAssignedWorkqueueData?.map(item => ([
                item.WorkQueuePriority || "NA",
                item.WorkQueueRuleName || "NA",
                item.Module || "NA",
                item.AssignedTo || "NA",
                item.WorkQueueCount || "NA",
                item.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA",
                item.WorkQueueDescription || "NA",
            ])) || [];

        const columns = activeKey === 'assignTo'
            ? [
                { title: "PRIORITY STATUS", dataKey: "priorityStatus" },
                { title: "RULE", dataKey: "rule" },
                { title: "MODULES", dataKey: "modules" },
                { title: "WORK QUEUE COUNT", dataKey: "workQueueCount" },
                { title: "ASSIGN TO", dataKey: "assignTo" },
                { title: "ASSIGNED DATE", dataKey: "assignedDate" },
            ]
            : [
                { title: "PRIORITY STATUS", dataKey: "priorityStatus" },
                { title: "RULE", dataKey: "rule" },
                { title: "MODULES", dataKey: "modules" },
                { title: "ASSIGN TO", dataKey: "assignTo" },
                { title: "CURRENT COUNT", dataKey: "currentCount" },
                { title: "ASSIGN DATE", dataKey: "assignDate" },
                { title: "DESCRIPTION", dataKey: "description" },
            ];

        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            styles: { fontSize: 8, cellPadding: 2, overflow: 'linebreak' },
            headStyles: { fillColor: [22, 160, 133], textColor: [255, 255, 255], halign: 'left' },
        });

        doc.save(activeKey === 'assignTo' ? 'assign_to_workqueue.pdf' : 'view_assigned_workqueue.pdf');
    };


    // Function to handle Word download
    const handleDownloadWord = () => {
        const dataToExport = activeKey === 'assignTo'
            ? workqueuesData.map(item => [
                String(item?.WorkQueuePriority || "NA"),
                String(item?.WorkQueueRuleName || "NA"),
                String(item?.Module || "NA"),
                String(item?.AssignedTo || "NA"),
                String(item?.WorkQueueCount || "NA"),
                String(item?.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA"),
            ])
            : getViewAssignedWorkqueueData.map(item => [
                String(item?.WorkQueuePriority || "NA"),
                String(item?.WorkQueueRuleName || "NA"),
                String(item?.Module || "NA"),
                String(item?.AssignedTo || "NA"),
                String(item?.WorkQueueCount || "NA"),
                String(item?.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA"),
                String(item?.WorkQueueDescription || "NA"),
            ]);

        const headers = activeKey === 'assignTo'
            ? ["PRIORITY STATUS", "RULE", "MODULES", "ASSIGN TO", "WORK QUEUE COUNT", "ASSIGNED DATE"]
            : ["PRIORITY STATUS", "RULE", "MODULES", "ASSIGN TO", "CURRENT COUNT", "ASSIGN DATE", "DESCRIPTION"];

        const tableRows = [
            new TableRow({ children: headers.map(header => new TableCell({ children: [new Paragraph(header)] })) }),
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        const table = new Table({ rows: tableRows });

        const doc = new Document({
            creator: "Assigned To Workqueue",
            title: "Assigned To Workqueue Report",
            description: "A detailed report of assigned workqueues.",
            sections: [{ children: [table] }]
        });

        Packer.toBlob(doc).then(blob => saveAs(blob, activeKey === 'assignTo' ? "assign_to_workqueue.docx" : "view_assigned_workqueue.docx"));
    };

    // Function to handle Print
    const handlePrint = () => {
        const dataToExport = activeKey === 'assignTo'
            ? workqueuesData.map(item => [
                item.WorkQueuePriority || "NA",
                item.WorkQueueRuleName || "NA",
                item.Module || "NA",
                item.WorkQueueCount || "NA",
                item.AssignedTo || "NA",
                item.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA",
            ])
            : getViewAssignedWorkqueueData.map(item => [
                item.WorkQueuePriority || "NA",
                item.WorkQueueRuleName || "NA",
                item.Module || "NA",
                item.AssignedTo || "NA",
                item.WorkQueueCount || "NA",
                item.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA",
                item.WorkQueueDescription || "NA",
            ]);

        const headers = activeKey === 'assignTo'
            ? ["PRIORITY STATUS", "RULE", "MODULES", "WORK QUEUE COUNT", "ASSIGN TO", "ASSIGNED DATE"]
            : ["PRIORITY STATUS", "RULE", "MODULES", "ASSIGN TO", "CURRENT COUNT", "ASSIGN DATE", "DESCRIPTION"];

        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;
        const printWindow = window.open('', '', 'height=600, width=800');
        printWindow.document.write(tableHtml);
        printWindow.document.close();
        printWindow.print();
    };

    const handleDownloadImage = () => {
        // Check if there is data to export
        if (!workqueuesData || workqueuesData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        // Dynamically set data and headers based on the active tab (assignTo or viewAssigned)
        const dataToExport = activeKey === 'assignTo'
            ? workqueuesData.map(item => [
                item.WorkQueuePriority || "NA",
                item.WorkQueueRuleName || "NA",
                item.Module || "NA",
                item.WorkQueueCount || "NA",
                item.AssignedTo || "NA",
                item.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA",
            ])
            : getViewAssignedWorkqueueData.map(item => [
                item.WorkQueuePriority || "NA",
                item.WorkQueueRuleName || "NA",
                item.Module || "NA",
                item.AssignedTo || "NA",
                item.WorkQueueCount || "NA",
                item.AssignedDate ? moment(item.AssignedDate).format('DD/MM/YYYY') : "NA",
                item.WorkQueueDescription || "NA",
            ]);

        const headers = activeKey === 'assignTo'
            ? ["PRIORITY STATUS", "RULE", "MODULES", "WORK QUEUE COUNT", "ASSIGN TO", "ASSIGNED DATE"]
            : ["PRIORITY STATUS", "RULE", "MODULES", "ASSIGN TO", "CURRENT COUNT", "ASSIGN DATE", "DESCRIPTION"];

        // Create the table HTML to be rendered
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a container div for the table
        const printContainer = document.createElement('div');
        printContainer.innerHTML = tableHtml;

        // Append the print container to the body (for rendering purposes)
        document.body.appendChild(printContainer);

        // Use html2canvas to capture the table as an image
        html2canvas(printContainer, {
            scale: 2, // Increase scale for better quality
            useCORS: true, // Enable CORS for external resources
            width: printContainer.scrollWidth, // Set width based on content
            height: printContainer.scrollHeight, // Set height based on content
            scrollX: 0, // Ensure no scroll position is captured
            scrollY: -window.scrollY // Adjust for current scroll position
        }).then(canvas => {
            // Remove the print container after rendering
            document.body.removeChild(printContainer);

            // Convert the canvas to an image
            const imgData = canvas.toDataURL('image/png');

            // Create a temporary download link
            const link = document.createElement('a');

            // Set the download file name based on the active tab
            link.download = activeKey === 'assignTo' ? "assign_to_workqueue.png" : "view_assigned_workqueue.png";

            link.href = imgData; // Set the link to the image data
            link.click(); // Trigger the download by simulating a click event
        }).catch(error => {
            console.error("Error generating image:", error);
            alert("There was an error while generating the image. Please try again.");
        });
    };

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={false}
                        showDownloadDropdown={true}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                {/* <div className='customermanagement-content-container'> */}
                {/* <div className="customermanagement-content"> */}

                {signInDetails[0]?.SignInType === "User" ? (
                    <div className="customer-management-container">
                        <div className='customermanagement-content-container pt-0'>
                            <UsersWQViewAssignedToTable
                                getViewAssignedWorkqueueData={getViewAssignedWorkqueueData}
                                loading={loading}
                                workqueuesDatas={workqueuesDatas}
                                setSearchQueryForViewAssigned={setSearchQueryForViewAssigned}
                                searchTextForViewAssigned={searchTextForViewAssigned}
                                setSearchTextForViewAssigned={setSearchTextForViewAssigned}
                                setSearchParamsForViewAssigned={setSearchParamsForViewAssigned}
                            />
                        </div>
                    </div>
                ) : (
                    <Row className='m-0 work-queue-tabs'>
                        <Col className='p-0'>
                            <Tab.Container activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                                <Nav variant="tabs">
                                    <Nav.Item>
                                        <Nav.Link eventKey="assignTo">
                                            Assign To
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="viewAssigned">
                                            View Assigned
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <div className="customer-management-container">
                                    <div className='customermanagement-content-container pt-0'>
                                        <Tab.Content className="customermanagement-content">
                                            <Tab.Pane eventKey="assignTo">
                                                <WorkQueuesAssignToTable workqueuesData={workqueuesData} loading={loading} workqueuesDatas={workqueuesDatas} searchText={searchText} setSearchText={setSearchText} setSearchQuery={setSearchQuery} assignedModulesDropdown={assignedModulesDropdown} setSearchParams={setSearchParams} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="viewAssigned">
                                                <WorkQueuesViewAssignedTable getViewAssignedWorkqueueData={getViewAssignedWorkqueueData} loading={loading} workqueuesDatas={workqueuesDatas} setSearchQueryForViewAssigned={setSearchQueryForViewAssigned} searchTextForViewAssigned={searchTextForViewAssigned} setSearchTextForViewAssigned={setSearchTextForViewAssigned} setSearchParamsForViewAssigned={setSearchParamsForViewAssigned} />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </div>
                                </div>
                            </Tab.Container>
                        </Col>
                    </Row>)
                }

                {/* </div> */}
                {/* </div> */}
            </Main >
        </div >
    );
};

export default WorkQueues;
